import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { Link as RouterLink } from 'react-router-dom';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TradingButton from '../components/Trader/TradingButton';
import { useLocation } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import { useSelector } from 'react-redux';


export default function Footer() {
  const appMode = useSelector((state) => state.mode.mode);
  const [value, setValue] = React.useState(0);
  const ref = React.useRef(null);
  const location = useLocation();
  const { pathname } = location;

  return (
    <Box sx={{ display: {md: 'none'},  pb: 7 }} ref={ref}>
      <CssBaseline />
      <Paper sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 20000,
        backgroundColor: appMode === 'dark' ? '#000000' : '#e8e8e8',
        borderTop: appMode === 'dark' ? '1px solid #444' : '1px solid #d0d0d0'
      }} elevation={3}>
      {pathname === '/trade' ? 
         <TradingButton/>
        : 
        <BottomNavigation
        sx={{
          alignItems: 'center',
          padding: '10px',
          backgroundColor: appMode === 'dark' ? '#000000' : '#e8e8e8',
          '& .MuiBottomNavigationAction-root': {
            padding: '6px 8px',
            minWidth: 'auto',
            color: appMode === 'dark' ? '#e0e0e0' : '#424242',
            borderBottom: '6px solid transparent',
            transition: 'border-bottom 0.3s ease',
            '&.Mui-selected': {
              color: '#ffb11a',
              borderBottom: '6px solid #ffb11a',
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.625rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              color: 'inherit'
            }
          }
        }}
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction component={RouterLink} to="/" label="Home" icon={
             <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/home-white_lcjht2.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/home_w5a5yr.png'} sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar>  
          } />
          <BottomNavigationAction component={RouterLink} to="/start-trading" label="Trade" icon={
            <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/candle_l9uey7-white_bkdamr.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/candle_l9uey7_b6819z.png'} sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
          </Avatar> } />

          <BottomNavigationAction component={RouterLink} to="/copy-plans" label="Copy Trading" icon={
            <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378458/analytics_tjm1c0-white_qnmqka.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378458/analytics_tjm1c0_ybaoen.png'} sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar> 
            } />
          <BottomNavigationAction component={RouterLink} to="/package/Trading Bots" label="Trading Bots" icon={
            <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/robot_yozduf-white_ubuatj.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/robot_yozduf_1_hxwv2u.png'} sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar> 
          } />

          <BottomNavigationAction component={RouterLink} to="/assets" label="Assets" icon={
            <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/wallet_1_vmr3li-white_i8qljf.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/wallet_1_vmr3li_ab9ero.png'} sx={{ padding: '5px', width: 30, height: 30, color: '#fff'}}>
            </Avatar> 
          } />
          
          {/* <BottomNavigationAction label="Our Menu" icon={<MenuBookIcon />}/> */}
          
        </BottomNavigation>
        }
      </Paper>
    </Box>
  );
}
